import { FC, memo } from 'react';
import { useSelector } from 'react-redux';

import Content from 'src/components/Content/Content';
import { Store } from 'app-redux/types/storeTypes';
import { ContentContainerInterface } from 'components/Content/declarations';

const ContentContainer: FC<ContentContainerInterface> = ({
  bgColor,
  content,
  pageName,
}) => {
  const serverCookies = useSelector((store: Store) => store.server.app.serverCookies);

  return (
    <Content
      content={content}
      pageName={pageName}
      serverCookies={serverCookies}
      bgColor={bgColor}
    />
  );
};

export default memo(ContentContainer);
